import { useState } from "react";

import { Span } from "@icg360/design-system";

import type { DataSection } from "../../../types";
import styles from "./MobilePaymentSection.module.css";

interface PaymentSectionProps {
  paymentSections: DataSection[];
}

export const MobilePaymentSection = ({
  paymentSections
}: PaymentSectionProps) => {
  const [selectedOption, setSelectedOption] = useState(
    paymentSections[0].label
  );
  const selectedSection = paymentSections.find(
    section => section.label === selectedOption
  );
  const dueNowIndex = 0;
  return (
    <div className={styles.mobilePaymentsContainer}>
      <select
        name="payments"
        id="payment-options"
        onChange={e => setSelectedOption(e.target.value)}
        value={selectedOption}
      >
        {paymentSections.map((sectionData, index) => (
          <option value={sectionData.label} key={index}>
            {sectionData.label}
          </option>
        ))}
      </select>
      {selectedSection?.fields.map((fieldData, index) => (
        <div className={styles.mobilePaymentRow} key={fieldData.term}>
          {index === dueNowIndex ? (
            <>
              <Span bold>{fieldData.label}</Span>
              <Span bold>{fieldData.value}</Span>
            </>
          ) : (
            <>
              <Span>{fieldData.label}</Span>
              <Span>{fieldData.value}</Span>
            </>
          )}
        </div>
      ))}
    </div>
  );
};
